// import Component from 'vue-class-component';

// /* eslint-disable import/first */

// Component.registerHooks([
//   'beforeRouteEnter',
//   'beforeRouteLeave',
//   'beforeRouteUpdate',
// ]);

import { init, domReady } from './';
import components from './components';
import config from './config';

import { library } from '@fortawesome/fontawesome-svg-core';

import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons/faRedoAlt';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons/faUserSecret';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import './style/index.scss';
// import './style/sai-search-category.scss';
import Vue from 'vue';
import { SAITicketService } from '@/libs/sai-ticket/dist/sai-ticket.umd.min.js';

library.add(
  faList,
  faChevronRight,
  faChevronLeft,
  faSearch,
  faSignOutAlt,
  faRedoAlt,
  faTimes,
  faTag,
  faUserSecret,
  faPlus
);
components['font-awesome-icon'] = FontAwesomeIcon;

console.log('init', { components, config });

const ticketConfig = { ticketInterval: 1800 };

Vue.use(SAITicketService, {
  config: ticketConfig,
  url: process.env.TICKET_URL,
  productId: process.env.PRODUCT_ID,
});

domReady(() => {
  init({ components, config });
});



// WEBPACK FOOTER //
// ./products/390/main.js